module.exports = __webpack_public_path__ + "static/img/c-2.0ef0a7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c-2.jpg
// module id = RCL5
// module chunks = 22